/* eslint-disable react/no-direct-mutation-state */
import React from 'react';
import { connect } from "react-redux";
import { Popup, ToolbarItem } from 'devextreme-react/popup';
import { FormattedMessage, injectIntl } from "react-intl";
import Form, { Item as FormItem, SimpleItem, RequiredRule, GroupItem, RangeRule } from 'devextreme-react/form';
import { withSnackbar } from 'notistack';
import { GetEvaluatedUserFilters } from "../../Templates/TemplateAdjust";

export const RESPONSES = {
    SAVE: 'SAVE',
    CANCEL: 'CANCEL',
};



class DataGridBaseBatchComModal extends React.Component {
    constructor(props) {
        super(props);
        this.validatorRef = React.createRef();
        this.validatorName = 'BatchCommunicateModalValidator';
        this.batchCommunicateFormRef = React.createRef();

        this.state = {
            visible: false,
            communicateAllowedUsers: null,
        }

    }
    componentDidUpdate(prevProps, prevState) {
        if (prevProps) {
            if (prevProps.visible !== this.props.visible) {
                this.setForm();
            }
        }
    }


    setForm = () => {
        if (this.props.visible) {
            const contractUsers = this.props.contractUsers?.map(a => ({
                accounttype: a.accounttype,
                accountid: a.accountid,
                contractuserid: a.contractuserid,
                rolepermissions: a.rolepermissions,
                user: a.user,
                useremail: a.useremail,
                party: a.usergroup,
                display: `${a.user} (${a.useremail})`
            })) || [];
            const contractUsersWithCommunicatePermission = [];
            for (let index = 0; index < contractUsers.length; index++) {
                const contractUser = contractUsers[index];
                const contractUserAccessRights = GetEvaluatedUserFilters(this.props.workflowItem?.defaultWF, this.props.workflowItem, this.props.contract, contractUser);
                if (contractUserAccessRights.accessAllowed && contractUserAccessRights?.mainNotice?.communicateAllowed) {
                    contractUsersWithCommunicatePermission.push(contractUser);
                }
            }
            
            this.setState({ visible: true, communicateAllowedUsers: contractUsersWithCommunicatePermission });
        }
        else{
            this.setState({ visible: false, communicateAllowedUsers: null });
        }
    }

    communicateClick = async () => {
        const validationRes = this.batchCommunicateFormRef.current.instance().validate();
        if (!validationRes.isValid) {
            return;
        }
        const actionsFormObj = this.batchCommunicateFormRef.current.instance().option("formData");
        this.setState({ visible: false, communicateAllowedUsers: null }, () => {
            this.props.onApproved(actionsFormObj.BatchCommunicateUser);
        });
    }


    // formFieldDataChanged = (e) => {
    //     const test = e.component.option("formData");
    //     console.log(e)

    // }
    render() {
        if (!this.state.visible) {
            return null;
        }
        return (
            <Popup
                visible={this.state.visible}
                // onHiding={this.onClose}
                showCloseButton={false}
                dragEnabled={true}
                hideOnOutsideClick={false}
                showTitle={true}
                title={this.props.intl.formatMessage({ id: 'BATCH_OPS.POPUP.COMMUNICATE.TITLE' }, { COUNT: this.props.selectedItemCount })}
                width={600}
                height='auto'>
                <>
                    <div>
                        <FormattedMessage id="BATCH_OPS.POPUP.COMMUNICATE.MESSAGE" values={{ COUNT: this.props.selectedItemCount }} />
                        <br />
                        <Form
                            ref={this.batchCommunicateFormRef}
                            showValidationSummary={true}
                            // onFieldDataChanged={this.formFieldDataChanged}
                        >
                            <GroupItem caption={"Select Communicating User"}>
                                <SimpleItem
                                    label={{ visible: false }}
                                    dataField={"BatchCommunicateUser"}
                                    editorType='dxSelectBox'
                                    isRequired={true}
                                    editorOptions={{
                                        dataSource: this.state.communicateAllowedUsers,
                                        displayExpr: "display",
                                        valueExpr: "accountid",
                                    }}
                                >
                                    {/* <RequiredRule message={"User is required"} /> */}
                                </SimpleItem>
                            </GroupItem>
                        </Form>
                    </div>
                </>
                <ToolbarItem
                    widget="dxButton"
                    toolbar="bottom"
                    location="after"
                    options={{
                        text: this.props.intl.formatMessage({ id: "GENERAL.FORMS.BUTTON_CANCEL" }),
                        onClick: () => { this.props.onCancel(); }
                    }}>
                </ToolbarItem>
                <ToolbarItem
                    widget="dxButton"
                    toolbar="bottom"
                    location="after"
                    options={{
                        text: this.props.intl.formatMessage({ id: "ACTIONS.BUTTON.COMMUNICATE" }),
                        type: "success",
                        stylingMode: "outlined",
                        onClick: this.communicateClick
                    }}>
                </ToolbarItem>
            </Popup>
        );
    }
}

const mapStateToProps = store => ({
    contract: store.contract.contract,
    contractUsers: store.contract.users
});

export default connect(mapStateToProps)(withSnackbar(injectIntl(DataGridBaseBatchComModal)));